/* globals _, gtag, mixpanel, mp, MARKETING_MIXPANEL_TOKEN, PRICING3_INFO */

import {createElem} from 'common/util/dom';

import {getFtProperties} from '../utils/ft-properties';

export class PricingPage {
  bootstrap() {
    // Needs cookie persistence to share the distinct_id with tracking from the
    // app servers.

    // Remove bad event handlers assigned by Mayven JS so buttons in "Compare Plans" table header work:
    $(`.nav-table a.link-spread, .nav-table a.btn`).off(`click`);

    // optional chaining to prevent JS errors due to JS/ad blockers
    // eslint-disable-next-line camelcase,no-unused-expressions,babel/no-unused-expressions
    mp?.report?.init_tracking?.(MARKETING_MIXPANEL_TOKEN, {persistence: `cookie`}, `marketing`);
    if (parseInt(mp.globals.user_id, 10)) {
      mixpanel.marketing.identify(mp.globals.user_id);
    }
    const ftProperties = getFtProperties();
    mixpanel.marketing.register_once(ftProperties);
    mixpanel.marketing.people.set_once(ftProperties);

    mixpanel.marketing.people.increment(`Pricing Page Views`);

    const pageVersion = $(`.v2`).length ? `America's pricing test 2020` : `Original`;
    const isPricing2023 = $(`body`).attr(`pricing-2023`) === `true`;
    mixpanel.track(`View pricing page`, {
      mp_note: `Came from: ${document.referrer}`,
      'Pricing Version': $(`.startup-plan`).length ? `Startup Credits Advertised` : `3.0`,
      'Page Version': pageVersion,
      'Is pricing 2023': isPricing2023,
    });

    // Wire the buttons.

    // main enterprise "contact us" button
    const clickContactUs = (ev) => {
      const origEv = ev.originalEvent;
      const location = origEv.detail && origEv.detail.location;
      mixpanel.track(`Contact Us Request Click`, {
        'Contact Us Source': location || `Pricing Page - Enterprise box`,
        'Is pricing 2023': isPricing2023,
      });
    };

    $(`body`).on(`click`, `.marketo-contact`, clickContactUs).on(`planBuilderContactUsClick`, clickContactUs);

    const ctaButton = $(`a[pricing-2023]`);
    mixpanel.track_links(ctaButton, `Choose Plan`, (el) => {
      const href = el.href;
      let planName;

      if (href.includes(`enterprise`)) {
        planName = `enterprise`;
      } else if (href.includes(`growth`)) {
        planName = `growth`;
      } else {
        // should never happen - seeing this value appear in P3 should trigger an investigation
        planName = `unknown`;
      }

      return {
        'Plan Type': planName,
        'Resource Type': `Event`,
        'Is pricing 2023': true,
      };
    });

    // "Talk to a sales representative" button at the bottom of the page
    $(`.contact-form-wrapper .arrow-button`).click(() => {
      mixpanel.track(`Contact Us Request Click`, {
        'Contact Us Source': `Pricing Page - talk to a sales representative`,
      });
    });

    // "Plan no longer supported" warning:
    $(`body`).on(`click`, `.box-alert a.icon-close`, (evt) => {
      $(evt.target).closest(`.box-alert`).slideUp();
    });

    $(`.link-spread`).click((ev) => {
      const dataPlan = ev.target.dataset.plan;
      let planName;
      switch (dataPlan) {
        case `mtu_starter`:
          planName = `MTU Starter`;
          break;
        case `mtu_growth`:
          planName = `MTU Growth`;
          break;
        case `mtu_enterprise`:
          planName = `MTU Enterprise`;
          break;
        default:
          return;
      }

      mixpanel.track(`Choose Plan`, {
        'Plan Type': planName,
        'Resource Type': isPricing2023 ? `Event` : `MTU`,
        'Page Version': pageVersion,
        'Is pricing 2023': isPricing2023,
      });
      mixpanel.marketing.track(`Plan Selected`, {
        'Plan Tier': dataPlan,
        'Plan Type': isPricing2023 ? `Event` : `MTU`,
        'Page Version': pageVersion,
        'Is pricing 2023': isPricing2023,
      });
    });

    // Plan Transition modals:
    this.setUpModals([`transition-mtu-free`], {
      click: () => {
        mixpanel.track(`Convert to MTU Free Plan`, {
          'Plan Type': `Free`,
          'Resource Type': `MTU`,
          'Selected MTU billing cycle': `Monthly`,
          'Selected event/MTU plan volume': 1000,
        });
      },
      submit: (ev, modal) => {
        if (ev.detail.action === `confirm` && !modal.getAttribute(`data-submitted`)) {
          const updatedUrl = new URL(location.href);
          updatedUrl.searchParams.delete(`transition`);
          modal.setAttribute(`data-submitted`, `true`);
          $.post(
            `/api/app/billing/selfserve_transition`,
            {
              account_id: PRICING3_INFO.account_id,
            },
            () => window.location.replace(updatedUrl.toString()),
          );
        }
      },
    });

    $(`#transition`).click(() => {
      // TODO: what properties should we track here
      mixpanel.track(`Convert to MTU Free Plan`, {
        'Plan Type': `Free`,
        'Resource Type': `MTU`,
        'Selected MTU billing cycle': `Monthly`,
        'Selected event/MTU plan volume': 1000,
      });
      const transitionConfirm = document.getElementById(`transition_confirm`);
      transitionConfirm.setAttribute(`open`, `true`);
      transitionConfirm.addEventListener(`submit`, (ev) => {
        if (ev.detail.action === `confirm` && !ev.target.transitionConfirm.getAttribute(`data-submitted`)) {
          ev.target.transitionConfirm.setAttribute(`data-submitted`, `true`);
          $.post(`/api/app/billing/selfserve_transition`, {account_id: PRICING3_INFO.account_id}, () =>
            location.reload(),
          );
        }
      });
    });

    // TODO: Fix Marketo to ensure a reliable signup flow (then yank this out).
    mp.utility.maybeInjectAdblockWarningBanner();

    // Init downgrade form.
    $(`a.link-spread.starter_downgrade`).click(() => {
      const cancelHolder = document.getElementById(`cancel_dialog_holder`);

      if (cancelHolder.children.length === 0) {
        const reasonValues = mp.account.reason_choices().map((elem) => elem[1]);

        const downgradeDialog = createElem(`mp-cancel-account-dialog`, {
          'downgrade-reasons': JSON.stringify(reasonValues),
          'account-id': PRICING3_INFO.account_id,
          plans: JSON.stringify(PRICING3_INFO.plan_info),
          'request-type': `downgrade_type`,
          open: `true`,
          'is-legacy': `false`,
        });

        downgradeDialog.addEventListener(`close`, () => {
          cancelHolder.removeChild(downgradeDialog);
        });
        downgradeDialog.addEventListener(`submit`, () => {
          window.location.reload();
        });

        cancelHolder.appendChild(downgradeDialog);
      }
    });

    // Set up sticky main nav header and "Compare Plans" table header:
    const wrapper = $(`#wrapper`);
    if (!wrapper.get(0)) {
      return; // not relevant to the current page
    }

    const tableSection = $(`section.pricing-core-features`);
    const header = $(`header.header-v3`);
    let headerStart, tableStart, tableEnd;

    function calculateStickyBoundaries() {
      headerStart = wrapper.get(0).offsetTop;
      tableStart = tableSection.get(0).offsetTop + 50;
      tableEnd = tableStart + tableSection.get(0).offsetHeight - 200;
    }
    calculateStickyBoundaries();

    $(window)
      .resize(calculateStickyBoundaries)
      .scroll(() => {
        if (header) {
          header.toggleClass(`header-sticky-banner-aware`, window.scrollY > headerStart);
        }
        if (tableSection) {
          tableSection.toggleClass(`sticky-header`, window.scrollY > tableStart && window.scrollY < tableEnd);
        }
      });

    // Fix table "tab" navigation on mobile devices:
    jQuery(`.nav-table li`).click(function () {
      const tab = $(this);
      const menu = tab.parent();
      const table = menu.parent().next();
      const planClass = [`free`, `growth`, `enterprise`][tab.index()];
      table.removeClass().addClass(`table-stripe-wrap`).addClass(planClass);
    });

    // "Transition" boxes/banners close buttons:
    $(`body`).on(`click`, `.box-alert a.icon-close, .banner-alert a.icon-close`, (evt) => {
      $(evt.target)
        .closest(`.box-alert, .banner-alert`)
        .slideUp(function () {
          calculateStickyBoundaries(); // re-calc sticky boundaries after banner above header disappears
        });
    });

    function trackFeatureToggle($body) {
      if (!$body.hasClass(`toggleable`)) {
        return;
      }

      mixpanel.track(`Pricing Page - Toggle Feature Row`, {
        expanded: $body.hasClass(`expanded`),
        'feature title': $body.find(`.feature-title`)[0]?.childNodes[0]?.data?.trim(),
      });
    }

    // Set up collapsible "Compare Plans" table for Pricing 2023...
    $(`section.pricing-core-features .row:first-child`).click((ev) => {
      const body = $(ev.target).closest(`.body`);
      const rows = body.children().not(`:first-child`);
      body.toggleClass(`expanded`);
      rows.hide();
      if (body.hasClass(`expanded`)) {
        rows.fadeIn(`fast`);
      }
      trackFeatureToggle(body);
    });

    // ...and for the non-experimental pricing page.
    // TODO (Pricing 2023 Cleanup): Remove
    $(`section.pricing-core-features tr:first-child`).click((ev) => {
      const body = $(ev.target).closest(`tbody`);
      const rows = body.children().not(`:first-child`);
      body.toggleClass(`expanded`);
      rows.hide();
      if (body.hasClass(`expanded`)) {
        rows.fadeIn(`fast`);
      }
      trackFeatureToggle(body);
    });

    const showTransition = new URL(location.href).searchParams.get(`transition`);
    if (showTransition) {
      this.openTransitionModal();
    }
  }

  openTransitionModal() {
    const modal = document.querySelector(`mp-confirm.transition-mtu-free`);
    if (modal) {
      modal.setAttribute(`open`, `true`);
    }
  }

  setUpModals(modalClasses, handlers = {}) {
    modalClasses.forEach((modalClass) => {
      const modal = document.querySelector(`mp-confirm.${modalClass}`);
      const buttons = document.querySelectorAll(`a.transition.${modalClass}`);

      if (modal) {
        buttons.forEach((button) => {
          button.addEventListener(`click`, (ev) => {
            modal.setAttribute(`open`, `true`);
            handlers && handlers.click && handlers.click(ev, button);
          });
        });

        modal.addEventListener(`submit`, (ev) => {
          handlers && handlers.submit && handlers.submit(ev, modal);
        });

        // Without this, the modal will not re-open after closing via X... wtf mp-confirm
        modal.addEventListener(`change`, (ev) => {
          modal.setAttribute(`open`, ev.detail.state === `open`);
          handlers && handlers.change && handlers.change(ev, modal);
        });
      }
    });
  }

  trackFormSubmit(type) {
    return function (form) {
      let superProps;
      if (form) {
        // used marketo form
        const vals = form.vals();
        superProps = {
          'Company Size': vals.Company_Size__c,
          Company: vals.Company,
          $email: vals.Email,
          $name: vals.completeName,
        };
      } else {
        superProps = {
          'Company Size': this.$form.find(`.input.size-input`).val(),
          Company: this.$form.find(`.input.company-input`).val(),
          $email: this.$form.find(`.input.email-input`).val(),
          $name: this.$form.find(`.input.name-input`).val(),
        };
      }
      mixpanel.marketing.register_once(superProps);
      mixpanel.marketing.people.set_once(superProps);
      mixpanel.marketing.track(
        `Form Submit`,
        Object.assign({}, superProps, {
          'Form Type': type,
          'Page Name': `Pricing`,
        }),
      );
      const over1k = [`1001-5000`, `5001-10000`, `10001+`];

      if (window.gtag) {
        if (_.contains(over1k, superProps[`Company Size`])) {
          // Event snippet for Submit Contact Us Info - 1000+ Company Size conversion page
          gtag(`event`, `conversion`, {send_to: `AW-1060727094/DThgCMGuuZ0BELbS5fkD`});
        } else {
          // Event snippet for Submit Contact Us Info - 10-1000 Company Size conversion page
          gtag(`event`, `conversion`, {send_to: `AW-1060727094/RWL_CPSouZ0BELbS5fkD`});
        }
        // Event snippet for Submit Lead conversion page
        gtag(`event`, `conversion`, {send_to: `AW-1060727094/TZH1COezuZ0BELbS5fkD`});
      }
    };
  }
}

mp.utility.onDocumentReady(() => new PricingPage().bootstrap());
